import { ChangeEvent, useState } from "react";
import {
  FormControl,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import Grid from "@mui/material/Grid";

import colors from "../../../../styles/colors/colors";
import fontWeight from "../../../../styles/mui/fontWeight";
import {
  ReviewDetailsOutterGrid,
  DateControl,
  SelectControl,
  ReviewCertifyFields,
} from "../../styles/Review";
import DatePicker from "../../../../components/formComponents/DatePicker";
import { rules } from "../../../../utils/validations/Validations";
import { FormInputText } from "../../../../components/formComponents/FormInputText";
import { Controller } from "react-hook-form";

export interface PropsFromState {
  control: any;
}

type ReviewDetailsProps = PropsFromState;

const ReviewCertify: React.FC<ReviewDetailsProps> = ({
  control,
}: ReviewDetailsProps) => {
  const [ismedicaidMedicareChecked, setmedicaidMedicareChecked] =
    useState(false);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setmedicaidMedicareChecked(checked);
  };

  const rendertypography = (value: string) => {
    return (
      <Typography
        variant="h6"
        color={colors.fonts[20]}
        fontWeight={fontWeight.Weight[4]}
      >
        {value}
      </Typography>
    );
  };

  return (
    <Grid container sx={ReviewDetailsOutterGrid}>
      <Grid size={{ xs: 12 }} pb={"0.6rem"}>
        <Typography
          variant="h6"
          color={colors.fonts[20]}
          fontWeight={fontWeight.Weight[3]}
        >
          <Typography
            component="span"
            variant="h6"
            color={colors.fonts[20]}
            fontWeight={fontWeight.Weight[4]}
          >
            FOR MEDICARE BENEFICARY:
          </Typography>{" "}
          THE F2F ENCOUNTER DATE MUST BE WITHIN 90 DAYS PRIOR TO OR 30 DAYS
          AFTER THE DATE OF HOME CARE ADMISSION AND RELATED TO THE REASON FOR
          THE HOME CARE REFERRAL.
        </Typography>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Typography
          variant="h6"
          color={colors.fonts[20]}
          fontWeight={fontWeight.Weight[4]}
        >
          I CERTIFY THAT THIS PATIENT IS UNDER MY CARE AND THAT I, OR A NP/PA
          WORKING WITH ME, HAD A FACE TO FACE ENCOUNTER ON:
        </Typography>
      </Grid>
      <Grid container sx={ReviewCertifyFields}>
        <Grid>
          <FormControl variant="standard" sx={DateControl}>
            <DatePicker
              name={`reviewDetail.FToFEncounterDate`}
              control={control}
              label={"F2F Encounter Date:"}
              allowFutureDate={true}
            />
          </FormControl>
        </Grid>
        <Grid>
          <FormControl sx={SelectControl} variant="standard">
            <FormInputText
              name={`reviewDetail.ProviderName`}
              control={control}
              label="Name of Provider:"
              helper={rules.providerName}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container size={{ xs: 12 }} sx={ReviewCertifyFields}>
        <Controller
          control={control}
          name={`reviewDetail.medicaidMedicareChecked`}
          defaultValue={false}
          render={({ field: { onChange, ref } }) => (
            <FormControlLabel
              label={
                <Grid size={{ xs: 12 }}>
                  {rendertypography(
                    "For Medicare Advantage Members: I certify that this member is considered homebound within the definition of homebound."
                  )}
                  {rendertypography(
                    "For Medicaid Members: I certify that this member requires home health care services."
                  )}
                </Grid>
              }
              control={
                <Checkbox
                  size="small"
                  checked={ismedicaidMedicareChecked}
                  onChange={(e) => {
                    onChange(e.target.checked);
                    handleChange(e);
                  }}
                  inputRef={ref}
                />
              }
            />
          )}
        />
      </Grid>
      <Grid container sx={ReviewCertifyFields} pb={"2rem"}>
        <Typography
          variant="subtitle2"
          color={colors.fonts[29]}
          fontWeight={fontWeight.Weight[3]}
        >
          Homebound means that leaving home takes considerable and taxing
          effort. A person may leave home for medical treatment or short,
          infrequent absences for non-medical reasons.
        </Typography>
      </Grid>
    </Grid>
  );
};

export default ReviewCertify;
